import React, { useState, useEffect } from 'react';
import { useThemeMode } from './AppStoreStyle';

const shuffleArray = (array: any) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};
interface NumericKeypadProps {
  onKeyPress: (key: string) => void;
  useHaptic?: boolean; // New prop to control haptic feedback
}
const NumericKeypad: React.FC<NumericKeypadProps> = ({ onKeyPress }) => {
  const initialKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
  const [keys, setKeys] = useState([...initialKeys]);
  const [middleKey, setMiddleKey] = useState('0');
  useEffect(() => {
    shuffleKeys();
  }, []);
  const { isDarkMode } = useThemeMode();

  const shuffleKeys = () => {
    const shuffledKeys = shuffleArray([...initialKeys]);
    const newMiddleKey = shuffledKeys.pop(); // Remove the last key to place in the middle
    setKeys(shuffledKeys);
    setMiddleKey(newMiddleKey);
  };
  const handleKeyPress = (key: any) => {
    if (key === 'random') {
      shuffleKeys();
    } else {
      onKeyPress(key);
    }
  };

  return (
    <div className={``}>
      <div className={`keypad-container`}>
        {keys.map((key, index) => (
          <button
            key={index}
            className={'key'}
            onClick={() => handleKeyPress(key)}
          >
            {key}
          </button>
        ))}
        <button className={'key'} onClick={() => handleKeyPress('random')}>
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.78437 6.33203C4.025 5.65078 4.41562 5.01016 4.96562 4.46328C6.91875 2.51016 10.0844 2.51016 12.0375 4.46328L12.5719 5.00078H11.5C10.9469 5.00078 10.5 5.44766 10.5 6.00078C10.5 6.55391 10.9469 7.00078 11.5 7.00078H14.9969C15.55 7.00078 15.9969 6.55391 15.9969 6.00078V2.50078C15.9969 1.94766 15.55 1.50078 14.9969 1.50078C14.4437 1.50078 13.9969 1.94766 13.9969 2.50078V3.60078L13.45 3.05078C10.7156 0.316406 6.28438 0.316406 3.55 3.05078C2.7875 3.81328 2.2375 4.71016 1.9 5.66953C1.71562 6.19141 1.99063 6.76016 2.50938 6.94453C3.02813 7.12891 3.6 6.85391 3.78437 6.33516V6.33203ZM1.71875 9.04141C1.5625 9.08828 1.4125 9.17266 1.29062 9.29766C1.16562 9.42266 1.08125 9.57266 1.0375 9.73516C1.02813 9.77266 1.01875 9.81328 1.0125 9.85391C1.00312 9.90703 1 9.96016 1 10.0133V13.5008C1 14.0539 1.44687 14.5008 2 14.5008C2.55313 14.5008 3 14.0539 3 13.5008V12.4039L3.55 12.9508C6.28438 15.682 10.7156 15.682 13.4469 12.9508C14.2094 12.1883 14.7625 11.2914 15.1 10.332C15.2844 9.81016 15.0094 9.24141 14.4906 9.05703C13.9719 8.87266 13.4 9.14766 13.2156 9.66641C12.975 10.3477 12.5844 10.9883 12.0344 11.5352C10.0813 13.4883 6.91563 13.4883 4.9625 11.5352L4.95937 11.532L4.425 11.0008H5.5C6.05312 11.0008 6.5 10.5539 6.5 10.0008C6.5 9.44766 6.05312 9.00078 5.5 9.00078H2.0125C1.9625 9.00078 1.9125 9.00391 1.8625 9.01016C1.7875 9.01953 1.76562 9.02578 1.71875 9.04141Z"
              fill={isDarkMode ? 'white' : 'black'}
            />
          </svg>
        </button>
        <button
          key="middle"
          className={`${'key'} ${'!w-full'}`}
          onClick={() => handleKeyPress(middleKey)}
        >
          {middleKey}
        </button>
        <button className={'key'} onClick={() => handleKeyPress('delete')}>
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5 7H4.33L9.92 1.41L8.5 0L0.5 8L8.5 16L9.91 14.59L4.33 9H16.5V7Z"
              fill={isDarkMode ? 'white' : 'black'}
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default NumericKeypad;
